import React, {Component} from 'react'
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {alertActions, sourceActions, zoomIntegrationActions} from "../_actions";
import {ZoomRecordingListings} from "../components/zoomIntegration/ZoomRecordingListings";
import PseudoModal from "../_components/PseudoModal";
import {__isAvailable} from "../_helpers/commons/utility.helper";
import LoaderMessage from "../_components/LoaderMessage";
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import ErrorMessage from "../_components/ErrorMessage";
import {userService} from "../_services";
import {authenticationState} from "../_constants/commons/authenticationState";

// COMPONENT ##########################################################

class OrderGistZoom extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentRecording: {},                   // holds the current recording selection
        };
    }

    componentDidMount() {
        this.startConnection();     // initiate connection if necessary; else load list
    }

    startConnection() {
        const {authState} = this.props;
        const isLoggedIn = (authState === authenticationState.LOGGED_IN);
        const zoomAvailable = this.isZoomAvailable();

        if( !isLoggedIn || !zoomAvailable) {
            this.props.history.push('/zoom');   // redirect to landing page
        } else {
            this.props.getRecordings();         // fetch recordings
        }
    }

    isZoomAvailable() {
        const {users} = this.props;
        return userService.isConnectedToZoom(users);
    }

    isListingRecordings = () => {
        const {zoom} = this.props;
        return __isAvailable(zoom) && __isAvailable(zoom.getRecordings);
    };

    isRecordingListReady = () => {
        const {zoom} = this.props;
        return (zoom && zoom.getRecordings && zoom.getRecordings.loaded);
    };

    isRecordingListLoading = () => {
        const {zoom} = this.props;
        return (zoom && zoom.getRecordings && zoom.getRecordings.loading);
    };

    isRecordingListError = () => {
        const {zoom} = this.props;
        return (zoom && zoom.getRecordings && zoom.getRecordings.failed);
    };

    isRecordingSelected = () => __isAvailable(this.state.currentRecording);

    handleSelectRecording = (recording) => {
        this.setState({currentRecording: recording});
    };

    getRecordingGistTitle = (recording) => {
        const {t, zoom} = this.props;
        const list = zoom.getRecordings.data.meetings;
        const recordingMeeting = list.find(meeting => meeting.uuid === recording.meeting_id);
        const meetingTopic = __isAvailable(recordingMeeting) ? recordingMeeting.topic : t('Meeting');
        return meetingTopic + " | " + recording.name;
    };

    updateRecordingList = (query) => {
        this.props.getRecordings(query);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const {t} = this.props;
        const {currentRecording: recording} = this.state;

        if (__isAvailable(recording)) {
            let source = {
                'title': this.getRecordingGistTitle(recording),
                'probeUri': recording.download_url,
                'integration': {
                    "type": "ZOOM",
                    "recordingId": recording.id,
                    "meetingUuid": recording.meeting_id,
                    "contentType": recording.content_type
                },
                "hosted": true,                         // zoom sources are always hosted
            };
            this.props.validateRecording(source);       // validate recording now
        } else {
            this.props.dispatchEmptyFieldError({"errorMsg": t("Please select a recording before ordering.")});
        }
    };

    getCancelState = (fallback="/media") => {
        const {history, historyInfo, t} = this.props;
        const isBackUrlCodeAuth = () => {
            const lastHistory = historyInfo.list.back.peek();                               // get the 1st back history
            return __isAvailable(lastHistory) && lastHistory.search.startsWith("?code");    // verify if integration auth url
        };

        let cancelState;
        // if backUrl is not domain safe or code auth, then customized cancel else regular cancel
        if(__isAvailable(historyInfo) && (!historyInfo.isDomainSafe || isBackUrlCodeAuth()) ) {
            cancelState = {
                text: t("Return to Portfolio"),
                handleCancel: function() { history.push(fallback) },
            }
        } else {
            cancelState = {
                text: t("Cancel"),
                handleCancel: function() { history.goBack() },
            }
        }
        return cancelState;
    };

    render() {
        const {t, alert, order} = this.props;

        const maxWidth = '650px';
        const listingsCancel = this.getCancelState();

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header/>
                    <>
                        {/* when the list of recording is ready for display */}
                        {this.isRecordingListReady() &&
                        PseudoModal({
                            title: t("Order a Gist"),
                            messages: [
                                <ZoomRecordingListings
                                    handleSelectRecording={this.handleSelectRecording}
                                    maxWidth={maxWidth}
                                    updateRecordingList={this.updateRecordingList}
                                />
                            ],
                            cancelText: listingsCancel.text,
                            submitText: t("Validate"),
                            handleSubmit: this.handleSubmit,
                            handleCancel: () => listingsCancel.handleCancel(),
                            alert: alert,
                            submittedProp: {submitted: order.isVerifying, pendingText: t("Validating")},
                            maxWidth: maxWidth,
                            disabled: !this.isRecordingSelected(),
                        })
                        }

                        {/* when the list of recording is being fetched */}
                        {this.isRecordingListLoading() &&
                        LoaderMessage({
                            title: t("Order a Gist"),
                            messages: [],
                            alert: alert,
                            loadingText: t("Fetching recordings..."),
                            maxWidth: maxWidth,
                        })
                        }

                        {/* when there was issue with getting the list of recording */}
                        {this.isRecordingListError() &&
                        ErrorMessage({
                            title: t("Order a Gist"),
                            messages: [],
                            alert: alert,
                            maxWidth: maxWidth,
                        })
                        }
                    </>
                    <Footer/>
                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state){
    const {integrations, alert, order, historyInfo, users, authentication} = state;
    const {zoom} = integrations;
    const {authState} = authentication;
    return {
        zoom, alert, order, historyInfo, users, authState
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getRecordings                : (query = {})     => dispatch(zoomIntegrationActions.getRecordings(query)),
        validateRecording            : (recording)          => dispatch(sourceActions.validateLink(recording)),
        dispatchEmptyFieldError      : (msg)                => dispatch(alertActions.error(msg)),
    }
}

const connectedOrderGistZoom = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderGistZoom));
export { connectedOrderGistZoom as OrderGistZoom };
